import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Select from "react-select";
import * as Yup from "yup";
import {
  linkEmpList,
  linkEmployee,
} from "../../../redux/actions/fieldForceAction";
import { AdminButton } from "../../buttons/versionHistoryBtn";
import "../modal.css";
import ChangeSaved from "../../popups/ChangeSaved";
import ErrorPopup from "../../popups/ErrorPopup";
import {
  customerDivisionFeildForceList,
  customerDivisionList,
  customerAddDivision,
} from "../../../redux/actions/customerActions";

const AddDivisionModal = ({
  show,
  handleClose,
  user_id,
  customerDetail,
  refreshData,
  headquater,
  userType,
}) => {
  const dispatch = useDispatch();
  const [divisionDataList, setDivisionDataList] = useState([]);
  const [feildForceList, setFeildForceList] = useState([]);
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [divisionID, setDivisionID] = useState("");

  const initialValues = {};
  const validationSchema = Yup.object().shape({});
  useEffect(() => {
    dispatch(
      customerDivisionList({}, onDivisionFetchSuccess, onDivisionfetchError)
    );
  }, []);

  useEffect(() => {
    setShowErrorPopup(false);
    onSetSuccessShow(false);
    if (divisionID && divisionID != "") {
      dispatch(
        customerDivisionFeildForceList(
          { division_id: divisionID, hq_id: headquater?.headQuater?.id },
          onFeildForceFetchSuccess,
          onFeildForcefetchError
        )
      );
    }
  }, [divisionID]);

  const onDivisionFetchSuccess = (data) => {
    let newArr = data.data.data.map((ele) => ({
      value: ele.id,
      label: `${ele.name} - ${ele.code}`,
    }));
    setDivisionDataList(newArr);
  };
  const onDivisionfetchError = (err) => {
    console.log(err);
  };

  const onFeildForceFetchSuccess = (data) => {
    setFeildForceList(data);
  };
  const onFeildForcefetchError = (err) => {
    console.log(err);
  };

  const onSubmit = (values) => {
    values["doctor_id"] = userType == "doctor" ? user_id : null;
    values["pharmacy_id"] = userType == "pharmacy" ? user_id : null;
    values["hq_id"] = headquater?.headQuater?.id;
    values["division_ids"] = [values["division_ids"]];
    console.log("values", values);
    dispatch(customerAddDivision(values, onSuccess, onError));
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
    handleClose();
    // fetchFFdetail();
  };

  const onSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    refreshData();
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    handleClose();
  };

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      dialogClassName=""
      contentClassName="link-modal col-5 mx-auto p-2 fn_Nunito"
    >
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ setFieldValue, values }) => (
            <Form className="p-1">
              <p className="fn_Nunito fw_700 fs_18 my-2 px-0">
                Add Division to Customer
              </p>
              <div className="my-4">
                <label className="Neutral_Color fs_14">User ID</label>
                <p className="fs_14"> {customerDetail.code}</p>
              </div>
              <div className="my-4">
                <label className="Neutral_Color fs_14">Headquater:</label>
                <p className="fs_14"> {headquater?.headQuater?.name}</p>
              </div>
              <div className="my-4">
                <label className="Neutral_Color fs_14">
                  Link With Division
                </label>
                <Field>
                  {({ form, Field }) => (
                    <Select
                      options={divisionDataList}
                      styles={customStyles}
                      {...Field}
                      id="division_ids"
                      name="division_ids"
                      placeholder="Select Division Id"
                      onChange={(selectedOption) => {
                        form.setFieldValue(
                          "division_ids",
                          selectedOption.value
                        );
                        setDivisionID(selectedOption.value);
                      }}
                    />
                  )}
                </Field>
              </div>
              <div className="my-4">
                <label className="Neutral_Color fs_14">
                  Company Feild Force
                </label>
                <Field>
                  {({ form, Field }) => (
                    <Select
                      options={feildForceList}
                      styles={customStyles}
                      {...Field}
                      id="fieldForce_id"
                      name="fieldForce_id"
                      placeholder="Select Company Feild Force"
                      onChange={(selectedOption) => {
                        form.setFieldValue(
                          "fieldForce_id",
                          selectedOption.value
                        );
                      }}
                    />
                  )}
                </Field>
              </div>
              <div className="d-flex justify-content-end align-items-center gap-3">
                <button
                  type="button"
                  onClick={() => handleClose()}
                  className="modal-logout-btn fs_14 fw_700 px-4 py-2"
                  style={{ width: "130px" }}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="modal-cancel-btn fs_14 text-white py-2 px-4 fw_700"
                  style={{ width: "130px" }}
                >
                  Add
                </button>
              </div>
            </Form>
          )}
        </Formik>
        <ChangeSaved show={onSuccessShow} title={onSuccessMsg} />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </ModalBody>
    </Modal>
  );
};

export default AddDivisionModal;
export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
